/* eslint-disable eslint-comments/no-restricted-disable */
/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { EmbeddedConfluencePageModalEntrypointEntrypointProps } from './EmbeddedConfluencePageModalEntrypoint.entrypoint.types.tsx';

type EmbeddedConfluencePageModalEntrypointComponent = EntryPointComponent<
	{},
	{},
	EmbeddedConfluencePageModalEntrypointEntrypointProps,
	{}
>;

export const embeddedConfluencePageModalEntrypoint: EntryPoint<
	EmbeddedConfluencePageModalEntrypointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<EmbeddedConfluencePageModalEntrypointComponent>(
		/* webpackChunkName: "async-embedded-confluence-page-modal" */ './EmbeddedPageModalEmbeddedPageModal.tsx',
	),
	getPreloadProps: () => ({}),
});
